<template>
<div class="yxtbiz-ai-robot__dialog--msg is-answer" :class="{'is-long-size': isSearch, 'bbs-search': mode === 'bbs', 'fullscreen': fullscreen}">
    <div :class="{'head-img':isSearch, 'mr12': !isSearch}" v-if="showPortrait">
        <yxtf-portrait size="28px" @click="isSearch && !isWaitAnswer && $emit('launch')" :class="{ 'hand': isSearch}" :imgUrl="settings.assistHeadImg"></yxtf-portrait>
        <span v-if="isSearch">问一问</span>
    </div>
    <component :is="anserComponents" :msg="msg" :isWaitAnswer="isWaitAnswer" :isSearch="isSearch" :fullscreen="fullscreen" :lastMsg="lastMsg" @resend="(val) => $emit('resend', val)" @feedback="$emit('feedback')"  @PromotClick="PromotClick"  @scrollToEnd="$emit('scrollToEnd')"></component>
</div>
</template>

<script>
import questionPromot from './answers//questionPromot.vue';
import commonAnswer from './answers/commonAnswer.vue';
import simpleAnswer from './answers/simpleAnswer.vue';
export default {
  name: 'Answer',
  components: {
    questionPromot,
    commonAnswer,
    simpleAnswer
  },
  props: {
    isWaitAnswer: {
      type: Boolean,
      default: false
    },
    showPortrait: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      default: () => {}
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'base'
    },
    lastMsg: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log('settings', this.settings);
  },
  inject: ['settings'],
  data() {
    return {
    };
  },
  computed: {
    anserComponents() { // 计算当前应该应该展示哪种类型的消息组件
      switch (this.msg.answerStatus) {
        case 0:
        case 2:
        case 3:
          return 'simpleAnswer';
        case 1:
          return 'commonAnswer';
        case 4:
          return 'questionPromot';
        default:
          return 'simpleAnswer';
      }
    }
  },
  methods: {
    PromotClick(item) {
      this.$emit('promot', item);
    }
  }
};
</script>
